<template>
    <b-modal id="modalEditShoppingItem"
      modal-class="modal-fullscreen"
      title="Boodschap bewerken"
      hide-backdrop
      hide-footer
      size="md"
      @show="initForm"
      @hidden="cleanup">
      <b-form ref="editItemForm" @submit.stop.prevent="submit()">
        <b-form-group label="naam:" :invalid-feedback="naamInvalidInfo" :state="naamState">
          <b-form-input ref="inputNaam" class="col-8 px-1 px-sm-2" required :state="naamState"
            v-model="form.naam" />
        </b-form-group>
        <b-form-group label="aantal:">
          <b-form-input class="col-6 px-1 px-sm-2" type="number" min="0" step="any"
            v-model="form.aantal" />
        </b-form-group>
        <b-form-group label="eenheid:">
          <b-form-select class="col-8" :options="unitOptions" v-model="form.eenheid" />
        </b-form-group>
        <b-form-group label="categorie:">
          <b-row><b-col class="col-8">
            <b-form-select :options="categoryOptions" v-model="form.categorie" />
          </b-col>
          <b-col class="col-4">
            <b-link v-b-modal.modalAddCategory class="ml-0">nieuw</b-link>
          </b-col></b-row>
        </b-form-group>
        <b-row class="border-0 mt-3">
          <b-col cols="auto" class="px-2">
            <b-button variant="danger" @click="remove"><b-icon icon="trash" /> Verwijderen</b-button>
          </b-col>
          <b-col cols="auto" class="ml-auto px-2">
            <b-button variant="secondary" @click="hide">Cancel</b-button>
            <b-button class="ml-2" variant="primary" @click="submit">OK</b-button>
          </b-col>
        </b-row>
      </b-form>
      <modal-add-category @categoryCreated="onCategoryCreated" :userID="userID" :categories="categories" />
    </b-modal>
</template>
<script>

import ModalAddCategory from "./ModalAddCategory.vue"

export default {
   name: "modal-edit-shopping-item",
   props: ["userID", "units", "categories", "item"],
   components: { ModalAddCategory },
   data() {
      return {
         naamState: null,
         naamInvalidInfo: "Geef een naam op",
         form: { id: null, naam: "", aantal: 1, eenheid: null, categorie: "diversen" },
      }
   },
   computed: {
      categoryOptions: function() {
         let opts = (this.categories || []).map(c => c.text).filter(Boolean)
         if(!opts.some(o => o.toLowerCase() === "diversen")) opts.unshift("diversen")
         const cur = this.form && this.form.categorie
         if(cur && !opts.some(o => o.toLowerCase() === cur.toLowerCase())) opts.unshift(cur)
         return opts
      },
      unitOptions: function() {
         let opts = (this.units || []).slice()
         const cur = this.form && this.form.eenheid
         if(cur && cur.id && !opts.some(u => u.value && u.value.id === cur.id)) {
            opts.unshift({ value: cur, text: cur.naam })
         }
         return opts
      },
   },
   methods: {
      initForm: function() {
         const it = this.item || {}
         const ingr = it.ingredient || {}
         // match the unit object from the master-data so the dropdown selects it by reference
         var eenheid = it.eenheid || null
         if(eenheid && this.units) {
            const match = this.units.find(u => u.value && u.value.id === eenheid.id)
            if(match) eenheid = match.value
         }
         this.form = {
            id: it.id,
            naam: ingr.naam || "",
            aantal: it.aantal,
            eenheid: eenheid,
            categorie: ingr.categorie || "diversen",
         }
         this.naamState = null
      },
      onCategoryCreated: function(naam) {
         this.form.categorie = naam
      },
      submit: function() {
         const naam = (this.form.naam || "").trim()
         if(naam === "") { this.naamState = false; return }
         this.$emit("save", {
            id: this.form.id,
            naam: naam,
            aantal: Number(this.form.aantal),
            eenheid: this.form.eenheid,
            categorie: this.form.categorie,
         })
         this.hide()
      },
      remove: function() {
         this.$emit("delete", { id: this.form.id })
         this.hide()
      },
      hide: function() {
         this.$bvModal.hide('modalEditShoppingItem')
      },
      cleanup: function() {
         this.naamState = null
      },
   },
}
</script>
